import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import GuideData from './GuideData';
import './UserGuideHome.css';
import { FaSearch } from 'react-icons/fa';




const UserGuideHome = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const filteredGuides = GuideData.filter((guide) =>
    guide.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    guide.description.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // חישוב עבור פג'ינציה
  const totalPages = Math.ceil(filteredGuides.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentGuides = filteredGuides.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="user-guide-home">
      <div className="guide-header">
        <h1 className="guide-title1">מדריך למשתמש</h1>
        <h1 className="guide-title2">במה נוכל לעזור?</h1>
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder="חיפוש מדריך..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1); // חזרה לעמוד 1 כשמחפשים
            }}
          />
          <FaSearch className="search-input-icon" />
        </div>
      </div>

      <div className="guide-cards">
        {currentGuides.map((guide, i) => {
          const IconComponent = guide.icon;
          return (
            <Link to={guide.path} className="guide-card" key={i}>
              <div className="icon"><IconComponent /></div>
              <h3>{guide.title}</h3>
              <p>{guide.description}</p>
            </Link>
          );
        })}
      </div>

      {/* ✅ פג'ינציה */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            הקודם
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              className={currentPage === i + 1 ? 'active' : ''}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            הבא
          </button>
        </div>
      )}
    </div>
  );
};

export default UserGuideHome;
